export class MoreButton {
  private button: HTMLElement
  private onClickHandler: () => boolean

  constructor(
    button: HTMLElement,
    onClick: () => boolean,
    shouldShow: boolean = true
  ) {
    this.button = button
    this.onClickHandler = onClick
    this.init()
    this.updateVisibility(shouldShow)
  }

  private init(): void {
    this.button.addEventListener('click', () => {
      const shouldShow = this.onClickHandler()
      this.updateVisibility(shouldShow)
    })
  }

  public updateVisibility(show: boolean): void {
    this.button.style.display = show ? 'block' : 'none'
  }
}
